import { cn } from '@app/utils/cn';
import { IconComponent } from '@typings';
import { Link, To } from 'react-router-dom';

interface Props {
  icon: IconComponent;
  title: string;
  link: To;
  isActive?: boolean;
}

export const MobileSidebarNavigationItem = ({ title, icon: Icon, link, isActive }: Props) => {
  return (
    <div className="relative">
      <Link
        to={link}
        className={cn(
          'flex flex-col items-center justify-center rounded-regular px-4 py-1 text-neutral-60 body-1 absolute-cursor-pointer hover:bg-neutral-96 focus-visible:focus-outline',
          { 'text-neutral-20': isActive },
        )}
      >
        <Icon className={cn('h-6 w-6 text-neutral-60 xs:h-5 xs:w-5', { 'text-neutral-20': isActive })} />
        <span className="hidden text-center xs:block">{title}</span>
      </Link>
    </div>
  );
};
